import React from 'react';


/*
PROPS:
props.added
props.handleClick
props.withPlus
props.withDelete
props.handleClickDelete
*/

// DEFAULT COMPONENT
const UniFormgenTagBtn = (props) => {
  // const timeoutRef = useRef(null);
  // const [clAnimation, setClAnimation] = useState("");

  let is_clickable = false;
  let handleClick = null;
  if (typeof props.handleClick === 'function') {
    handleClick = props.handleClick;
    is_clickable = true;
  }
  let handleClickDelete = null;
  if (typeof props.handleClickDelete === 'function') {
    handleClickDelete = props.handleClickDelete;
  }

  //
  let params = {};
  if (props.params) {
    params = props.params;
  }

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  // let cl = 'uniformcompo__field' + clAnimation + extraClass;
  let cl = 'uniformcompo__tag-btn' + extraClass;
  if (is_clickable === true) {
    cl += ' uniformcompo__tag-btn--clickable';
  }
  if (props.added === true) {
    cl += ' uniformcompo__tag-btn--added';
  }
  if (props.withDelete === true) {
    cl += ' uniformcompo__tag-btn--with-delete';
  }
  if (props.withPlus === true) {
    cl += ' uniformcompo__tag-btn--with-plus';
  }


  // <div className={cl} style={style}>
  return (
    <>
      <div className={cl} onClick={handleClick}>{
        props.withPlus === true && (
          <i className="fa fa-plus" aria-hidden="true"></i>
        )
      }{props.title}{
          props.withDelete === true && (
            <i onClick={handleClickDelete} className="fa fa-times-circle" aria-hidden="true"></i>
          )
        }</div>
    </>
  );
};

export default UniFormgenTagBtn;